<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>


<div id="header-container">
  <h1 class="title">Manage Global Scenarios</h1>
  <div class="button-container">
    <button mat-raised-button color="primary" id="add-global-scenario-button" class="action-button"
            (click)="openCreateGlobalScenario()">
      Create Global Scenario
    </button>
    <button mat-raised-button color="primary" id="edit-global-scenario-button" class="action-button"
            (click)="openEditGlobalScenario()" [disabled]="!this.selectedGlobalScenario">
      Edit Global Scenario
    </button>
    <button mat-raised-button color="warn" id="delete-global-scenario-button" class="action-button"
            (click)="onDelete()" [disabled]="!this.selectedGlobalScenario">
      Delete Global Scenario
    </button>
  </div>
</div>

<div class="gfs-table">

  <app-global-scenario-select-component
    #globalScenarioSelect
    [memberScenarioType]="0"
    [filterNonGM]="false"
    [user]="stateService.getUserGmid()"
    [displayedMemberColumns]="VEHICLE_PROPULSION_COLDEF_NO_FILTER"
    (confirmEvent)="onSelectGlobal($event)">
  </app-global-scenario-select-component>
</div>

